export default __webpack_public_path__ + "static/media/tenda.c2646c19.jpg";